module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/subscription-dialog/subscription-dialog.component.scss
// module id = ./src/app/admin/subscription-dialog/subscription-dialog.component.scss
// module chunks = main